/* Sirop theme — vanilla JS, no build step. */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Money ---------- */
  const formatMoney = (cents) => {
    const format = (window.siropCart && window.siropCart.moneyFormat) || '£{{amount}}';
    const value = (Number(cents) || 0) / 100;
    const withDelims = (n, decimals, thousands, decimal) => {
      const [whole, frac] = n.toFixed(decimals).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  };

  /* ---------- Toast ---------- */
  const toast = (title, description) => {
    $$('.toast').forEach((t) => t.remove());
    const el = document.createElement('div');
    el.className = 'toast';
    el.setAttribute('role', 'status');
    const strong = document.createElement('strong');
    strong.textContent = title;
    el.appendChild(strong);
    if (description) el.appendChild(document.createTextNode(description));
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 3500);
  };

  /* ---------- Mobile menu ---------- */
  const menuToggle = $('[data-menu-toggle]');
  const mobileNav = $('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const open = mobileNav.hidden;
      mobileNav.hidden = !open;
      menuToggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- Cart ---------- */
  const drawer = $('[data-cart-drawer]');
  const itemTemplate = $('#cart-item-template');

  const cartApi = async (path, body) => {
    const res = await fetch(root + path, body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
      : { headers: { Accept: 'application/json' } });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Cart error');
    return data;
  };

  const sizedImage = (url, width) => {
    if (!url) return '';
    return url + (url.includes('?') ? '&' : '?') + 'width=' + width;
  };

  const renderCart = (cart) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle('is-hidden', cart.item_count === 0);
    });
    if (!drawer) return;

    const count = cart.item_count;
    $('[data-cart-summary]', drawer).textContent =
      count === 0 ? 'Your basket is empty' : `${count} item${count !== 1 ? 's' : ''} in your basket`;
    $('[data-cart-empty]', drawer).hidden = count !== 0;
    $('[data-cart-footer]', drawer).hidden = count === 0;
    $('[data-cart-total]', drawer).textContent = formatMoney(cart.total_price);

    const list = $('[data-cart-items]', drawer);
    list.innerHTML = '';
    cart.items.forEach((item) => {
      const node = itemTemplate.content.firstElementChild.cloneNode(true);
      const img = $('img', node);
      if (item.image) { img.src = sizedImage(item.image, 128); img.alt = item.product_title; } else { img.remove(); }
      $('.cart-item__title', node).textContent = item.product_title;
      const options = (item.options_with_values || [])
        .filter((o) => o.value !== 'Default Title')
        .map((o) => o.value)
        .join(' • ');
      $('.cart-item__options', node).textContent = options;
      $('.cart-item__price', node).textContent = formatMoney(item.final_price);
      $('.cart-item__qty-value', node).textContent = item.quantity;
      node.dataset.key = item.key;
      node.dataset.quantity = item.quantity;
      list.appendChild(node);
    });
  };

  const refreshCart = () => cartApi('cart.js').then(renderCart).catch(() => {});

  const openDrawer = () => {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.classList.add('drawer-open');
    refreshCart();
    const close = $('.drawer__close', drawer);
    if (close) close.focus();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.classList.remove('drawer-open');
  };

  $$('[data-cart-open]').forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  $$('[data-cart-close]').forEach((el) => el.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer(); });

  if (drawer) {
    $('[data-cart-items]', drawer).addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-action]');
      if (!btn) return;
      const row = btn.closest('.cart-item');
      const qty = Number(row.dataset.quantity);
      const next = btn.dataset.action === 'increase' ? qty + 1 : btn.dataset.action === 'decrease' ? qty - 1 : 0;
      drawer.classList.add('is-busy');
      try {
        renderCart(await cartApi('cart/change.js', { id: row.dataset.key, quantity: Math.max(0, next) }));
      } catch (err) {
        toast('Could not update basket', err.message);
      } finally {
        drawer.classList.remove('is-busy');
      }
    });
  }

  /* ---------- Product page ---------- */
  const productEl = $('[data-product]');
  if (productEl) {
    const product = JSON.parse($('[data-product-json]', productEl).textContent);
    const form = $('[data-product-form]', productEl);
    const idInput = $('input[name="id"]', form);
    const qtyInput = $('[data-qty-input]', productEl);
    const priceEl = $('[data-product-price]', productEl);
    const addBtn = $('[data-add-to-cart]', productEl);
    const soldOutBtn = $('[data-sold-out]', productEl);

    // Gallery
    const slides = $$('.gallery__slide', productEl);
    const thumbs = $$('.gallery__thumb', productEl);
    let current = 0;
    const show = (i) => {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === current));
      thumbs.forEach((t, n) => {
        t.classList.toggle('is-active', n === current);
        t.setAttribute('aria-current', n === current ? 'true' : 'false');
      });
    };
    $$('[data-gallery-prev]', productEl).forEach((b) => b.addEventListener('click', () => show(current - 1)));
    $$('[data-gallery-next]', productEl).forEach((b) => b.addEventListener('click', () => show(current + 1)));
    thumbs.forEach((t, n) => t.addEventListener('click', () => show(n)));

    // Quantity
    $$('[data-qty]', productEl).forEach((b) => b.addEventListener('click', () => {
      const v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(b.dataset.qty));
      qtyInput.value = v;
    }));

    // Variants
    const optionGroups = $$('[data-option-index]', productEl);
    const selected = () => optionGroups.map((g) => {
      const btn = $('.variant-option.is-selected', g);
      return btn ? btn.dataset.value : null;
    });
    const updateVariant = () => {
      const values = selected();
      const variant = product.variants.find((v) => v.options.every((o, i) => values[i] == null || o === values[i]))
        || product.variants[0];
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      addBtn.hidden = !variant.available;
      soldOutBtn.hidden = variant.available;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    optionGroups.forEach((g) => g.addEventListener('click', (e) => {
      const btn = e.target.closest('.variant-option');
      if (!btn) return;
      $$('.variant-option', g).forEach((b) => b.classList.toggle('is-selected', b === btn));
      updateVariant();
    }));

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      addBtn.disabled = true;
      try {
        await cartApi('cart/add.js', { items: [{ id: Number(idInput.value), quantity: Math.max(1, parseInt(qtyInput.value, 10) || 1) }] });
        await refreshCart();
        toast('Added to basket', `${product.title} has been added to your basket.`);
      } catch (err) {
        toast('Could not add to basket', err.message);
      } finally {
        addBtn.disabled = false;
      }
    });

    // Sold out: open the next-batch sign-up dialog.
    const dialog = $('[data-next-batch]', productEl);
    if (soldOutBtn && dialog) {
      const dialogForm = $('[data-next-batch-form]', dialog);
      const done = $('[data-next-batch-done]', dialog);
      const error = $('[data-next-batch-error]', dialog);
      const submit = $('button[type="submit"]', dialogForm);

      soldOutBtn.addEventListener('click', () => {
        dialogForm.hidden = false;
        done.hidden = true;
        error.hidden = true;
        dialog.showModal();
      });
      $('[data-next-batch-close]', dialog).addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });

      dialogForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const email = dialogForm.email.value.trim();
        if (!isEmail(email)) {
          error.textContent = 'Please enter a valid email address.';
          error.hidden = false;
          return;
        }
        submit.disabled = true;
        submit.textContent = submit.dataset.loadingLabel;
        error.hidden = true;
        try {
          await klaviyoSubscribe(email);
          dialogForm.reset();
          dialogForm.hidden = true;
          done.hidden = false;
        } catch (_) {
          error.textContent = 'Something went wrong — please try again.';
          error.hidden = false;
        } finally {
          submit.disabled = false;
          submit.textContent = submit.dataset.label;
        }
      });
    }
  }

  /* ---------- Klaviyo ---------- */
  // Klaviyo locks page scrolling while a popup is open. When base.css hides a
  // popup that shouldn't show, the lock would stay, so lift it.
  const releaseScrollLock = () => {
    const body = document.body;
    if (!body.classList.contains('klaviyo-prevent-body-scrolling')) return;
    const anyVisible = $$('form.klaviyo-form').some((f) => f.getClientRects().length > 0);
    if (!anyVisible) body.classList.remove('klaviyo-prevent-body-scrolling');
  };
  new MutationObserver(releaseScrollLock).observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true });

  // Klaviyo's signup popup never opens by itself (base.css hides it). Its
  // "Sign up!" teaser tab opens it, so a click on the teaser (anything Klaviyo
  // renders outside a form) lets it show.
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    if (!t.closest('[class*="kl-private-reset"]') || t.closest('form')) return;
    document.body.classList.add('klaviyo-signup-open');
  }, true);

  /* ---------- Newsletter sign-up (Klaviyo client API, public site ID only) ---------- */
  function isEmail(value) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value); }

  function klaviyoApi(path, data) {
    const company = document.body.dataset.klaviyoCompany;
    return fetch(`https://a.klaviyo.com/client/${path}/?company_id=${encodeURIComponent(company)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({ data }),
    });
  }

  // Adds the email to the newsletter list set in Theme settings → Klaviyo.
  async function klaviyoSubscribe(email, firstName) {
    const res = await klaviyoApi('subscriptions', {
      type: 'subscription',
      attributes: { profile: { data: { type: 'profile', attributes: { email } } } },
      relationships: { list: { data: { type: 'list', id: document.body.dataset.klaviyoList } } },
    });
    if (!res.ok) throw new Error(String(res.status));
    if (firstName) {
      // Best effort: store the first name on the profile.
      klaviyoApi('profiles', { type: 'profile', attributes: { email, first_name: firstName } }).catch(() => {});
    }
  }

  const newsletter = $('[data-newsletter-form]');
  if (newsletter) {
    const msg = $('[data-newsletter-message]');
    const submit = $('button[type="submit"]', newsletter);
    const say = (key) => { msg.textContent = msg.dataset[key]; msg.hidden = false; };

    newsletter.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = newsletter.email.value.trim();
      const firstName = newsletter.first_name.value.trim().slice(0, 100);
      if (!isEmail(email)) { say('invalid'); return; }

      submit.disabled = true;
      submit.textContent = submit.dataset.loadingLabel;
      msg.hidden = true;
      try {
        await klaviyoSubscribe(email, firstName);
        newsletter.reset();
        say('success');
      } catch (_) {
        say('error');
      } finally {
        submit.disabled = false;
        submit.textContent = submit.dataset.label;
      }
    });
  }
})();
